import React from "react";
import CustomNavbar from "../components/CustomNavbar";
import Breadcrumb from "../components/Breadcrumb";
import FooterTwo from "../components/Footer/FooterTwo";
import FooterData from "../components/Footer/FooterData";

const phsCad = () => {
    let list = [
        "Drop down Menus will select correct support sizes based on user inputs.",
        "Auxiliary steel structures can be drawn.",
        "Ancillary components based on the support arrangement can be selected by simple icon menus. The size is predetermined by the previously selected part.",
        "The drawings is generated by placing each part on to its connecting part by object snaps. More details can be added using standard Autocad ™ features.",
        "The BOM is generated automatically with addition of each part on the screen, similarly a location plan with North arrow can be created on screen by inputting the grid reference.",
        "The BOM can be modified, collated, sorted on screen & if required can be extracted & exported as an MS Excel ™ file.",
        "A standard frame can be added from library or edited to suit for project.",
        "The drawing created resides in full 1:1 scale but is adjusted on screen into A4. The drawing can be copied & pasted on to client drawings with out loss of scale or information.",
    ];
  return (
    <div className="body_wrapper">
      <CustomNavbar
        slogo="sticky_logo"
        mClass="menu_four"
        nClass="w_menu ml-auto mr-auto"
      />
      <Breadcrumb
        breadcrumbClass="breadcrumb_area"
        imgName="breadcrumb/banner_bg.png"
        Ptitle="Pipe Hangers & Supports Software"
        Pdescription=""
      />
      <section className="contact_info_area sec_pad bg_color">
        <div className="container">
          <p>
            We are pioneers in implementing custom built software packages for
            Hanger Supports used in Piping industry. The software packages allow
            the user to produce accurate drawings of hanger assemblies based on
            inputs & a GUI based system. These packages are distributed to users
            at no cost. Please contact us for access to downloads.
          </p>

          <h6 className="f_p f_size_20 t_color3 f_500 mb_20">PHS CAD</h6>
          <p>
            This utility is designed to work in AutoCad ™ environment using the
            Autolisp ™ utility. All the products manufactured are built in as
            libraries using algorithms & parametric drawing tools.
          </p>
          <ul className="list-unstyled p_body">
              {list.map((x) => (
                   <li className="mt-3"> <i class="icon_check_alt2"></i>  {x}</li>
              )
              )}
             
          </ul>
        </div>
      </section>
      <FooterTwo FooterData={FooterData} />
    </div>
  );
};

export default phsCad;
